/**
 * NotFoundPage — quietly warm 404 in the v1.1 brand language.
 *
 * Sprint 11.4 redesign: KaivaIcon + Mono 404 badge + Geist 600 headline
 * + muted subline + Sienna-primary "Go home" link with ArrowLeft icon.
 */

import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
import { KaivaIcon } from './brand';

export function NotFoundPage() {
  return (
    <main
      className="relative flex min-h-screen flex-col items-center justify-center px-6 py-12 text-center"
      style={{
        background: 'hsl(var(--background))',
        color: 'hsl(var(--foreground))',
      }}
    >
      <div className="kv-substrate kv-substrate--subtle" aria-hidden="true" />
      <div className="relative z-10 flex flex-col items-center">
      <KaivaIcon size={40} />

      <span
        className="kv-eyebrow mt-6 inline-flex items-center"
        style={{
          padding: '4px 10px',
          borderRadius: 999,
          background: 'hsl(var(--sienna) / 0.08)',
          border: '1px solid hsl(var(--sienna) / 0.3)',
          color: 'hsl(var(--sienna-deep))',
        }}
      >
        404
      </span>

      <h1
        className="mt-4"
        style={{
          fontSize: 17,
          fontWeight: 600,
          letterSpacing: '-0.01em',
          color: 'hsl(var(--foreground))',
          margin: 0,
        }}
      >
        Page not found
      </h1>

      <p
        className="mt-1.5"
        style={{
          fontSize: 12,
          color: 'hsl(var(--muted-foreground))',
          letterSpacing: '0.01em',
          maxWidth: 360,
        }}
      >
        The path you followed isn't here anymore.
      </p>

      <Link
        to="/"
        className="mt-6 inline-flex items-center gap-1.5 transition-colors"
        style={{
          height: 32,
          padding: '0 14px',
          borderRadius: 8,
          background: 'hsl(var(--teal))',
          color: 'hsl(var(--slate-navy))',
          border: '1px solid hsl(var(--teal))',
          fontSize: 12.5,
          fontWeight: 500,
          textDecoration: 'none',
        }}
      >
        <ArrowLeft className="h-3 w-3" aria-hidden="true" />
        Go home
      </Link>
      </div>
    </main>
  );
}

export default NotFoundPage;
